import { IProject } from "../../types/projectData.types"

export enum ProjectActionType {
  FETCH_PROJECT_DATA_SETTINGS = "FETCH_PROJECT_DATA_SETTINGS",
  FETCH_PROJECT_DATA_SETTINGS_SUCCESS = "FETCH_PROJECT_DATA_SETTINGS_SUCCESS",
  FETCH_PROJECT_DATA_SETTINGS_ERROR = "FETCH_PROJECT_DATA_SETTINGS_ERROR",
}

interface FetchProjectDataSettings {
  type: ProjectActionType.FETCH_PROJECT_DATA_SETTINGS
}

interface FetchProjectDataSettingsSuccess {
  type: ProjectActionType.FETCH_PROJECT_DATA_SETTINGS_SUCCESS
  payload: IProject
}

interface FetchProjectDataSettingsError {
  type: ProjectActionType.FETCH_PROJECT_DATA_SETTINGS_ERROR
  payload: string
}

export type ProjectAction =
  | FetchProjectDataSettings
  | FetchProjectDataSettingsSuccess
  | FetchProjectDataSettingsError

export interface IProjectState {
  projectData: IProject
  loading: boolean
  error: string | null
}
